import { useMemo } from 'react';
import { Link, useTranslation } from '@weareconceptstudio/core';

//* Styles
import ButtonStyle from './style';

const Button = ({ btnType, text, className, onClick, url, type = 'button', disabled = false, children, external = false, ariaLabel = url }) => {
	const { translate } = useTranslation();

	//! Checks
	const Component = useMemo(() => (url ? Link : 'button'), [url]);
	const customProps = useMemo(() => (url ? { url, ariaLabel, external } : { type, disabled }), [url, external, type, disabled, ariaLabel]);

	let btn;

	switch (btnType) {
		default:
			btn = (
				<ButtonStyle
					onClick={onClick || null}
					className={`btn ${btnType || ''} ${className || ''} ${disabled ? 'disabled' : ''}`}>
					<Component {...customProps}>
						<div className='outside-wrapper-button'>
							<div className='text-wrapper'>
								<span className='text-button'>{children || translate(text)}</span>
								<span className='text-button-hover'>{children || translate(text)}</span>
							</div>
						</div>
					</Component>
				</ButtonStyle>
			);
	}

	return btn;
};

export default Button;
